export const SCREEN_SIZES = {
  MOBILE: "(max-width: 599px)",
  TABLET: "(min-width: 600px)",
  DESKTOP: "(min-width: 1200px)",
};
